import { render, staticRenderFns } from "./LupaPassword.vue?vue&type=template&id=4ed235e6&scoped=true&"
import script from "./LupaPassword.vue?vue&type=script&lang=js&"
export * from "./LupaPassword.vue?vue&type=script&lang=js&"
import style0 from "./LupaPassword.vue?vue&type=style&index=0&id=4ed235e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed235e6",
  null
  
)

export default component.exports